let currentOrder = $('#checkout-main').data('order');

function showLeaveModal() {
    if ($('#leaveCartModal').length !== 0) {
        $('#leaveCartModal').remove();
    }
    const modalDialogContent = $('#validate-leave-cart-modal-content-template').html();
    $('body').append(modalDialogContent);
    window.dialogManager.openDialog('modal', '#leaveCartModal');
}

$('body').on('click', '.js-checkout-logo', () => {
    let isLowAts = currentOrder && currentOrder.isProductWithLowAts ? currentOrder.isProductWithLowAts : false;
    if (isLowAts) {
        showLeaveModal();
    } else {
        window.window.location.href = $('.js-checkout-logo').data('url');
    }
});
